/* eslint-disable no-void */
import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {
  private sidenav!: MatSidenav;

  constructor() { }

  public setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  public close(): void {
    void this.sidenav?.close();
  }

  public open(): void {
    void this.sidenav.open();
  }

  public toggle(): void {
    void this.sidenav.toggle();
  }

}
